<!-- <p>incident-ticket-dialog works!</p> -->
<div class="mat-dialog-header">
  <h1 mat-dialog-title>
    <strong>Create Incident Tickets</strong>
  </h1>
</div>
<mat-dialog-content class="mat-typography">
  <div class="tickets-dialog-options">
    <form [formGroup]="incidentTicket">
      <mat-form-field appearance="outline">
        <mat-label>Subject</mat-label>
        <mat-select formControlName="ticketSubject">
          <mat-option value="0">Missing Incident Details</mat-option>
          <mat-option value="1">Reporting Error</mat-option>
          <mat-option value="2">Device Error</mat-option>
          <mat-option value="3">Manual Incident Error</mat-option>
          <mat-option value="4">Other</mat-option>
        </mat-select>
      </mat-form-field>
      <br />
      <mat-form-field appearance="outline">
        <mat-label>Description</mat-label>
        <textarea
          formControlName="ticketDescription"
          cdkTextareaAutosize
          cdkAutosizeMinRows="4"
          cdkAutosizeMaxRows="1"
          matInput
        ></textarea>
      </mat-form-field>
    </form>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button mat-dialog-close>Close</button>
  <button
    [disabled]="incidentTicket.invalid"
    mat-raised-button
    [mat-dialog-close]="incidentTicket.value"
  >
    Submit
  </button>
</mat-dialog-actions>
